import { AxiosError } from 'axios'

const messages: Record<string, string> = {
  crm_not_found: 'Não encontramos esse CRM no CFM. Confira o número e a UF.',
  crm_not_regular: 'Esse CRM não está regular no CFM.',
  crm_required: 'Informe o número e a UF do CRM.',
}

export function crmErrorMessage(error: unknown): string | null {
  if (!(error instanceof AxiosError)) return null
  const code = error.response?.data?.code
  if (typeof code !== 'string') return null
  return messages[code] ?? null
}
